// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import dataV from '@jiaminghi/data-view'
import * as echarts from 'echarts';
import VueAnimateNumber from 'vue-animate-number'

import china from './utils/china.json'
echarts.registerMap('china', china)

Vue.use(VueAnimateNumber)
Vue.prototype.$echarts = echarts






Vue.use(dataV)
Vue.use(ElementUI);

Vue.config.productionTip = false




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
//开启js热更新
if (module.hot) {
    module.hot.accept();
  }



// WEBPACK FOOTER //
// ./src/main.js